import { NoraTextAreaInput } from 'ethos-design-system';
import React, { useContext, useEffect, useState } from 'react';

import { FlexGrid, FlexRow, Spacer } from '../../../../../common/components/v2';
import { Reason } from '../../../../../common/constants/reasons';
import { Resource } from '../../../../../common/constants/resource';
import { FeatureFlagsContext } from '../../../../../common/featureFlagsWrapper';
import { Aps } from '../../../../tasks/types/aps';
import { ReasonsChoicePanel } from '../../ReasonsChoicePanel';
import { RequiredFieldErrorBar } from '../../RequiredFieldErrorBar';
import { RequiredFieldTitle } from '../../RequiredFieldTitle';
import styles from '../../styles.module.scss';

export const APSLayout = ({
  aps,
  setAps,
  isExpanded,
  reasons,
  apsError,
}: {
  aps: Aps;
  setAps: React.Dispatch<React.SetStateAction<Aps>>;
  isExpanded: boolean;
  reasons: Reason[];
  apsError: boolean;
}) => {
  const { flags } = useContext(FeatureFlagsContext);
  const { isApsDoctorInfoEnabled } = flags;
  const [reasonDescription, setReasonDescription] = useState(
    aps.reasonDescription || '',
  );
  const [doctorInfo, setDoctorInfo] = useState(aps.doctorInfo || '');
  const [selectedReasons, setSelectedReasons] = useState(
    aps.reason || ([] as string[]),
  );

  useEffect(() => {
    const newAps = {} as Aps;
    if (isExpanded) {
      newAps.doctorInfo = doctorInfo;
      newAps.reason = selectedReasons;
      newAps.reasonDescription = reasonDescription;
    } else {
      setReasonDescription('');
      setDoctorInfo('');
      setSelectedReasons([] as string[]);
    }
    setAps(newAps);
  }, [isExpanded, reasonDescription, doctorInfo, selectedReasons.length]);

  return (
    <FlexGrid>
      {apsError && (
        <>
          <RequiredFieldErrorBar />
          <Spacer height={8} />
        </>
      )}
      {!isApsDoctorInfoEnabled && (
        <FlexRow>
          <RequiredFieldTitle title={Resource.DOCTOR_INFO_HEADER} />
          <NoraTextAreaInput
            name="doctors-info"
            data-tid="doctors-info-textarea"
            placeholder="Name, address, zipcode and phone number"
            textClassName={styles.TextareaInput}
            onChange={(ev: React.ChangeEvent<HTMLTextAreaElement>) => {
              setDoctorInfo(ev.currentTarget.value);
            }}
            value={doctorInfo}
          />
        </FlexRow>
      )}
      <FlexRow>
        <RequiredFieldTitle title={Resource.ORDER_REASON} />
        <ReasonsChoicePanel
          reasons={reasons}
          selectedReasons={selectedReasons}
          selectReasonsCallback={setSelectedReasons}
        />
        <NoraTextAreaInput
          name="aps-reason"
          data-tid="aps-reason-textarea"
          placeholder="Describe the reason"
          textClassName={styles.TextareaInput}
          onChange={(ev: React.ChangeEvent<HTMLTextAreaElement>) => {
            setReasonDescription(ev.currentTarget.value);
          }}
          value={reasonDescription}
        />
      </FlexRow>
    </FlexGrid>
  );
};
